export default __webpack_public_path__ + "static/air-corporate-logo-white-dda5c82425f5ddede56d0e685ace6b80.svg";